export const INTERCOM_APP_ID = "blsw8a15";
